import { memo, useCallback } from 'react';
import { Stack } from '@mui/material';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { useNavigate } from 'react-router';
import { DELETE_DISTRIBUTION_CENTER_ERRORS } from '../../constants';

type Props = {
  rowId: string;
  error: any;
  isLoading: boolean;
  onDelete: () => void;
  onClose: () => void;
  onOpen: () => void;
  isOpen: boolean;
};

const DistributionCentersActions = ({ rowId, error, isLoading, onDelete, ...props }: Props) => {
  const navigate = useNavigate();

  const handleEdit = useCallback(() => {
    navigate(`/inventory/distribution-centers/${rowId}/general/?edit=true`);
  }, [navigate, rowId]);

  return (
    <>
      <Stack direction='row' spacing={1}>
        <EditRowActions onClick={handleEdit} />
        <DeleteRowAction
          {...props}
          error={error}
          isLoading={isLoading}
          onDelete={onDelete}
          errors={DELETE_DISTRIBUTION_CENTER_ERRORS}
        />
      </Stack>
    </>
  );
};

export default memo(DistributionCentersActions);
